import { colors } from 'styles/colors';
import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },

  grid: {
    flexGrow: 1,

    '@media (max-width: 1500px)': {
      '& .ag-header, & .ag-header-container, & .ag-header-cell-text': {
        whiteSpace: 'unset',
      },
    },
  },
  institutionRow: {
    background: `${colors.neutralVeryLight} !important`,
    fontWeight: 'bolder',
    '&.ag-row-hover': {
      background: colors.neutralLight,
    },
  },
  unitRow: {
    '& > .ag-cell.indent-cell': {
      paddingLeft: '20px',
      paddingRight: 0,
    },
  },
});
